import { buildObjectFromArray } from '@utils/object';

export default function getProductsLocaleObject(products?: string[]): Record<string, string> {
  return buildObjectFromArray(products?.map((product) => `ggr_${product}_percent`), 'FORM_PERCENT_');
}
